import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import { PostCallWithErrorResponse } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import { SectionHeader, LineItem } from './AccountReportShared';

const BalanceSheetPage = () => {
  const { sidebar } = useContext(AppContext);
  const [balanceSheet, setBalanceSheet] = useState({});

  const isBalanced = balanceSheet?.TotalAssets === balanceSheet?.TotalLiabilities + balanceSheet?.TotalEquity;

  const getBalanceSheet = () => {
    PostCallWithErrorResponse(ApiConfig.GET_BALANCE_SHEET, JSON.stringify({})).then((res) => {
      if (res?.json?.Success) setBalanceSheet(res?.json?.Data);
    });
  };

  useEffect(() => {
    getBalanceSheet();
  }, []);

  return (
    <main className={sidebar ? "taskMain" : "cx-active taskMain"} id="cx-main">
      <div id="sales-main">
        <section className="cx-inneer-header">
          <div className="main-inner">
            <div className="left">
              <label>Balance Sheet</label>
            </div>
          </div>
        </section>

        <section className="mt-3">
          <div className="card border-0 p-4" style={{ borderRadius: '12px' }}>
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
              <h4 className="mb-0">Statement of Financial Position</h4>
              <span
                className={`badge rounded-pill px-3 py-3 ${isBalanced ? 'bg-success' : 'bg-danger'}`}
                style={{ fontSize: '0.85rem' }}
              >
               <span style={{position: "relative", bottom: "6px"}}>{isBalanced ? '● Balanced' : '● Unbalanced'}</span> 
              </span>
            </div>

            <div className="row g-4">
              {/* Assets */}
              <div className="col-12">
                <div className="p-3 rounded-3 mb-3 d-flex justify-content-between align-items-center" style={{ backgroundColor: '#eef2ff', border: '1px solid #c3dafe' }}>
                  <span className="fw-bold text-primary">Total Assets</span>
                  <span className="fw-bold text-primary fs-5">{balanceSheet?.TotalAssets}</span>
                </div>
                <div className="px-2">
                  {balanceSheet?.AssetGroups?.map((category, idx) => (
                    <div key={idx} className="mb-3">
                      <SectionHeader title={category?.GroupName} total={category?.TotalAmount} />
                      {category?.LineItems?.map((item, i) => <LineItem key={i} name={item?.LedgerName} value={item?.Amount} indent />)}
                    </div>
                  ))}
                </div>
              </div>

              {/* Liabilities */}
              <div className="col-md-6">
                <div className="p-3 rounded-3 mb-3 d-flex justify-content-between align-items-center" style={{ backgroundColor: '#fff5f5', border: '1px solid #feb2b2' }}>
                  <span className="fw-bold text-danger">Total Liabilities</span>
                  <span className="fw-bold text-danger fs-5">{balanceSheet?.TotalLiabilities}</span>
                </div>
                <div className="p-2 rounded" style={{ backgroundColor: '#fafafa' }}>
                  {balanceSheet?.LiabilityGroups?.map((category, idx) => (
                    <div key={idx} className="mb-2">
                      <SectionHeader title={category?.GroupName} total={category?.TotalAmount} />
                      {category?.LineItems?.map((item, i) => <LineItem key={i} name={item?.LedgerName} value={item?.Amount} indent />)}
                    </div>
                  ))}
                </div>
              </div>

              {/* Equity */}
              <div className="col-md-6">
                <div className="p-3 rounded-3 mb-3 d-flex justify-content-between align-items-center" style={{ backgroundColor: '#f0fff4', border: '1px solid #9ae6b4' }}>
                  <span className="fw-bold text-success">Total Equity</span>
                  <span className="fw-bold text-success fs-5">{balanceSheet?.TotalEquity}</span>
                </div>
                <div className="p-2 rounded" style={{ backgroundColor: '#fafafa' }}>
                  {balanceSheet?.EquityGroups?.map((category, idx) => (
                    <div key={idx} className="mb-2">
                      <SectionHeader title={category?.GroupName} total={category?.TotalAmount} />
                      {category?.LineItems?.map((item, i) => <LineItem key={i} name={item?.LedgerName} value={item?.Amount} indent />)}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Footer Note */}
            <div
              className="mt-4 p-3 text-center rounded-3"
              style={{
                fontSize: '0.875rem',
                backgroundColor: isBalanced ? '#f8f9fa' : '#fff5f5',
                border: `1px dashed ${isBalanced ? '#dee2e6' : '#fc8181'}`,
                color: isBalanced ? '#6c757d' : '#e53e3e',
              }}
            >
              {isBalanced
                ? `Assets (${balanceSheet?.TotalAssets}) equals Liabilities + Equity (${balanceSheet?.TotalLiabilities + balanceSheet?.TotalEquity})`
                : `Warning: Balance sheet is out of balance by ${Math.abs(balanceSheet?.TotalAssets - (balanceSheet?.TotalLiabilities + balanceSheet?.TotalEquity))}`}
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default BalanceSheetPage;
